import React, { useEffect, useState } from 'react'
import { Header, Icon, Loader, Select, Table, TableBody, TableCell, TableHeader, TableHeaderCell } from 'semantic-ui-react'
import { honeyCombStatusReport } from '../../../app/models/Restoration'
import { useStore } from "../../../app/stores/store";
import { toast } from 'react-toastify';

const HoneyCombStatusReport = () => {
    const { RestorationStore} = useStore();
    const[LoadData,setLoadData]=useState<honeyCombStatusReport[]>([]);
    const[loading,setloading]=useState<boolean>(false);
    const [countIdle,setCountIdle]=useState<number>(0);
    const [countInProgress,setCountInProgress]=useState<number>(0);
    const [countNotStart,setCountNotStart]=useState<number>(0);
    const [countAchieved,setCountAchieved]=useState<number>(0);
   const [reportType,setReReportType]=useState<string>('');
    const getRowStyle = (status:string) => {
        if (status === "Not Started" || status === "Idle Progress") {
            return { color: 'red' };
        } else {
            return {};
        }
    };
    const ApiCall = async () => {
        try {
          setloading(true);
          await RestorationStore.getLogStatus();
          const data=await RestorationStore.honeyCombStatusReport;
          setLoadData(data);
          setCountIdle(data.filter((x) => x.status==="Idle Progress").length);
          setCountInProgress(data.filter((x) => x.status==="InProgress").length);
          setCountNotStart(data.filter(x=>x.status==="Not Started").length);
          setCountAchieved(data.filter(x=>x.status==="Hours Achived").length);
          setloading(false);
        } catch (error) {
          toast.error('Error fetching data');
        }
      };
      const currentStatus=[
        { key: 1, text: 'Hours Achived', value: 'Hours Achived' },
        { key: 2, text: 'InProgress', value: 'InProgress' },
        { key: 3, text: 'Not Started', value: 'Not Started' },
        { key: 4, text: 'Idle Progress', value: 'Idle Progress' },
        
    ]

      useEffect(()=>{
        ApiCall();
        // eslint-disable-next-line
      },[])
      
  return (
    <>
    <div style={{ width : '80%', margin: 'auto',height:'80%'}}>
    <Header as='h2'>HoneyComb Status Report</Header>
    {loading ? (
        <div className="ui active centered inline loader"><Loader>Loading</Loader></div>
    ):(
        <div>
            <Header as='h3' style={{display:'flex',paddingLeft:20}}>Summary</Header>
            <div className="ui horizontal list" style={{display:'flex',padding:'0 20px',alignItems:'center'}} >
                    <h2 className="ui header" style={{display:'flex',paddingLeft:20,margin:20,alignItems:'center'}}>
                        <Icon className="user"/>
                        <div className="content" style={{textAlign:'center',color:countInProgress > 0 ? 'black' : 'red'}}>{countInProgress}
                            <div className="sub header">Working Employee Count</div>
                        </div>
                    </h2>
                    <h2 className="ui header"  style={{display:'flex',paddingLeft:20,margin:20,alignItems:'center'}}>
                    <Icon className="male"/>
                        <div className="content" style={{textAlign:'center',color:countInProgress === 0 ? 'black' : 'red'}}>{countIdle}
                            <div className="sub header">Idle Employee Count</div>
                        </div>
                    </h2 >
                    <h2 className="ui header" style={{display:'flex',paddingLeft:20,margin:20,alignItems:'center'}}>
                    <Icon className="user times"/>
                        <div className="content" style={{textAlign:'center',color:countInProgress === 0 ? 'black' : 'red'}}>{countNotStart}
                            <div className="sub header">Not Started Employee Count</div>
                        </div>
                    </h2>
                    <h2 className="ui header" style={{display:'flex',paddingLeft:20,margin:20,alignItems:'center'}}>
                    <Icon className="user times"/>
                        <div className="content">{countAchieved}
                            <div className="sub header">Hours Achieved Employee Count</div>
                        </div>
                    </h2>
            </div>
            <div>
                <div style={{display:'flex',paddingLeft:20,alignItems:'center'}}> 
                    <div style={{display:'flex',paddingLeft:20,alignItems:'center'}}>
                        <Header as='h3' textAlign='center'>
                            Employee Details
                            <br/>
                            <br/>
                        </Header>
                    </div>
                    <div style={{display:'flex',paddingLeft:20,alignItems: 'center', marginLeft: 'auto'}}>
                        <label style={{ marginLeft: '12px' }}>Current Status:</label>
                            <Select
                            placeholder="Select Lead ID"
                            selection
                            search           
                            options={currentStatus} 
                            clearable
                            //value={selectedLead}
                            //disabled={selectedTitle === ''}
                            onChange={(e:any,data:any)=>{setReReportType(data.value)}}
                            />
                    </div>
                </div>
                <div style={{ height: '71vh', overflow: 'auto' }}>
                    <Table class="ui celled table">
                        <TableHeader style={{ position: 'sticky', top: 0, zIndex: 1, background: 'white' }}>
                        <Table.Row>
                        <TableHeaderCell>S No</TableHeaderCell>
                        <TableHeaderCell>Cluster Name</TableHeaderCell>
                        <TableHeaderCell>Employee ID</TableHeaderCell>
                        <TableHeaderCell>Employee Name</TableHeaderCell>
                        <TableHeaderCell>Attendance Status </TableHeaderCell>
                        <TableHeaderCell>First Shot Started Time</TableHeaderCell>
                        <TableHeaderCell>Current Shot Started Time</TableHeaderCell>
                        <TableHeaderCell>No of Shot Locked</TableHeaderCell>
                        <TableHeaderCell>Working Hours</TableHeaderCell>
                        <TableHeaderCell>Current Status</TableHeaderCell>
                        </Table.Row>
                        </TableHeader>
                        <TableBody>
                        {LoadData.length === 0 ? (
                            loading ? 
                                (<Table.Row><TableCell colSpan={10} style={{textAlign:'center'}}><Loader>Loading...</Loader></TableCell></Table.Row>) : (<Table.Row><TableCell colSpan={10} style={{textAlign:'center'}}>{'Currently Data not Avaialabe'}</TableCell></Table.Row>) 
                        ):(
                            LoadData.filter(x=>x.status.includes(reportType)).map((data,index)=>(
                            <Table.Row key={index} style={getRowStyle(data.status)}>
                            <TableCell>{index+1}</TableCell>
                            <TableCell>{data.clusterName}</TableCell>
                            <TableCell>{data.employee_ID}</TableCell>
                            <TableCell>{data.employee_Name}</TableCell>
                            <TableCell>{data.ispresent===true ? "Present" : "No Log" }</TableCell>
                            <TableCell>{data.first_startTime}</TableCell>
                            <TableCell>{data.liveStartTime}</TableCell>
                            <TableCell>{data.cutlistHold}</TableCell>
                            <TableCell>{data.workingHours}</TableCell>
                            <TableCell>{data.status}</TableCell>
                            </Table.Row>
                            )))}
                        </TableBody>
                    </Table>
            </div>
            </div>
        </div>
    )}
    </div>
    
    </>
    
  )
}

export default HoneyCombStatusReport